/**
 * Moment Range Setup
 * This module ensures moment-range is properly initialized before use
 * to avoid "object is not extensible" errors in Vite.
 * 
 * Vite's module isolation can cause moment to become non-extensible before
 * moment-range tries to extend it. This initializer handles that properly.
 * 
 * CRITICAL: All moment locales must be loaded here in this module,
 * before moment is exported. This ensures Vite loads them in the correct
 * module context and they're available when components use moment.
 */

import moment from 'moment-timezone';
import { extendMoment } from 'moment-range';

// Load all locale data upfront, in this module context
// This is critical for Vite - it ensures locales are available globally
import 'moment/dist/locale/fr-ca';
import 'moment/dist/locale/en-ca';
import 'moment/dist/locale/en-gb';
import 'moment/dist/locale/en-au';
import 'moment/dist/locale/en-nz';
import 'moment/dist/locale/en-ie';
import 'moment/dist/locale/fr';

// Initialize extendMoment immediately (not lazily)
// This ensures moment-range patches are applied before any component uses it
// @ts-ignore
const MomentRange = extendMoment(moment);

export { moment, MomentRange };
export default MomentRange;
